import React from "react";
import { Routes, Route } from "react-router-dom";
import VencimientoDocumentosPage from "../pages/VencimientoDocumentosPage";

const VencimientoRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<VencimientoDocumentosPage />} />
    </Routes>
  );
};

export default VencimientoRoutes;
